.additionalButton {
    background-color: #e6f1ff;
    color: #016ef4;

    &:hover {
        color: #016ef4;
    }
}
